(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────────── */
  function openModal(modalId, productName) {
    var modal = document.getElementById(modalId);
    if (!modal) return;

    // Set the hidden product-name field (subject line in Shopify contact)
    modal.querySelectorAll('.ci-product-name-field').forEach(function (el) {
      el.value = productName;
    });

    modal.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Focus first visible input after animation
    var firstInput = modal.querySelector('input:not([type="hidden"])');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 120);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  /* ── Click delegation ───────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    // Open trigger
    var openBtn = e.target.closest('[data-open-contact-inquiry]');
    if (openBtn) {
      var modalId = openBtn.getAttribute('data-modal');
      var productName = openBtn.getAttribute('data-product') || '';
      openModal(modalId, productName);
      return;
    }

    // Close (overlay or X button)
    var closeEl = e.target.closest('[data-close-contact-inquiry]');
    if (closeEl) {
      closeModal(closeEl.closest('.contact-inquiry-modal'));
      return;
    }
  });

  /* ── ESC key ────────────────────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.contact-inquiry-modal:not([hidden])').forEach(closeModal);
    }
  });

  /* ── Form submission ────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.contact-inquiry-form');
    if (!form) return;
    e.preventDefault();

    var modal = form.closest('.contact-inquiry-modal');
    var submitBtn = form.querySelector('[type="submit"]');
    var bodyField = form.querySelector('[name="contact[body]"]');
    var productName = modal ? (modal.dataset.product || '') : '';
    var originalBody = bodyField ? bodyField.value : '';
    var originalBtnText = submitBtn ? submitBtn.textContent : '';

    // Prepend product name to body for the agent context
    if (bodyField && productName) {
      bodyField.value = 'מוצר: ' + productName + '\n\n' + originalBody;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = '...שולח';
    }

    var formData = new FormData(form);

    fetch(form.action || '/contact', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Server returned ' + response.status);
        return response.json().catch(function () { return {}; });
      })
      .then(function () {
        // Show success panel
        var formWrap = modal && modal.querySelector('.ci-form-wrap');
        var successEl = modal && modal.querySelector('.ci-success');
        if (formWrap) formWrap.setAttribute('hidden', '');
        if (successEl) successEl.removeAttribute('hidden');

        // Restore body field value (in case form is reused)
        if (bodyField) bodyField.value = originalBody;

        // Auto-close after 4 s, then reset
        setTimeout(function () {
          closeModal(modal);
          setTimeout(function () {
            if (formWrap) formWrap.removeAttribute('hidden');
            if (successEl) successEl.setAttribute('hidden', '');
            form.reset();
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalBtnText;
            }
          }, 400);
        }, 4000);
      })
      .catch(function () {
        if (bodyField) bodyField.value = originalBody;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalBtnText;
        }
        alert('אירעה שגיאה בשליחת הטופס. אנא נסה שוב.');
      });
  });
})();
